import { configureStore } from '@reduxjs/toolkit';
import graphSlice from './nodemapSlice'; // Ensure your slice is defined
import taskReducer from './taskSlice';

export const store = configureStore({
    reducer: {
        graph: graphSlice,
        tasks: taskReducer,
    },
});
